





import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { IFavorisState, favorisFacadeBase } from './favoris.state';
import { Favoris } from './favoris.model';
import { FavorisService } from './favoris.service';



@Injectable()
export class FavorisFacade extends favorisFacadeBase  {


 	constructor(_store: Store<IFavorisState>, private _favorisService: FavorisService) {
        super( Favoris, _store);
    }

}
